import { render, staticRenderFns } from "./Bons.vue?vue&type=template&id=3d566a68&"
import script from "./Bons.vue?vue&type=script&lang=ts&"
export * from "./Bons.vue?vue&type=script&lang=ts&"
import style0 from "./Bons.vue?vue&type=style&index=0&id=3d566a68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports